import React, { useContext } from 'react';
import { bool } from 'prop-types';
import { podFulFillmentUtils } from '@thd-olt-component-react/fulfillment';
import { Button } from '@thd-olt-component-react/button';
import classNames from 'classnames';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { ProductPodGroupContext } from '../../ProductPodGroupContext';
import { ProductPodContext } from '../../ProductPodContext';

export const ProductSeeSimilarItems = ({ isMobileDoubleColumn }) => {

  const {
    onSimilarItemsClick,
    product,
    showSimilarItem,
    showSimilarItemButton
  } = useContext(ProductPodContext);

  const { isFulfillable } = podFulFillmentUtils;
  const { info } = product || {};
  const { isBuryProduct = false } = info || {};

  const {
    handleProductPodExpansion
  } = useContext(ProductPodGroupContext);

  const hideSimilarItemLink = isFulfillable(product) || !isBuryProduct;

  const {
    channel
  } = useContext(ExperienceContext);
  const similarButtonEnabled = !(isMobileDoubleColumn && !showSimilarItemButton);
  const isMobile = channel === 'mobile';
  const SimilarInStockButton = classNames({
    'product-pod__customs--margin': similarButtonEnabled && isMobile,
    'similar-items-link': !similarButtonEnabled
  });

  if ((!showSimilarItem && hideSimilarItemLink) || !handleProductPodExpansion) {
    return null;
  }

  const similarItemBtnClick = () => onSimilarItemsClick(similarButtonEnabled);

  return (
    <Button
      tag="a"
      className={SimilarInStockButton}
      link={!similarButtonEnabled}
      dark={similarButtonEnabled}
      outline={similarButtonEnabled}
      small={similarButtonEnabled && isMobile}
      onClick={similarItemBtnClick}
    >
      {similarButtonEnabled ? 'View Similar in Stock' : 'See similar items'}
    </Button>
  );
};

ProductSeeSimilarItems.propTypes = {
  isMobileDoubleColumn: bool
};
ProductSeeSimilarItems.defaultProps = {
  isMobileDoubleColumn: false
};
ProductSeeSimilarItems.displayName = 'ProductSeeSimilarItems';
